import axios from 'axios'
export const verifyToInscription = () =>
    axios.get('inscription/valid_user/')

export const updateProfile = (form) =>
    axios.post('inscription/update_user/', form)

export const verifySurvey = () =>
    axios.get('users/survey/')

export const saveSurvey = ( data ) =>
    axios.post('users/survey_save/', data)



// WEBPACK FOOTER //
// ./src/utils/userData.js